import {useMappedState} from 'redux-react-hook'

export default function useGetUserAsset () {
  const mapState = state => state?.entities?.userAsset || {}
  return useMappedState(mapState)
}
